import React, { useEffect, useState } from "react";
import { Link as LinkIcon } from "lucide-react";
import { fetchContent, fetchDataSources } from "../../services/api";
import { DEFAULT_CONTENT } from "../../data/contentDefaults";
import "./DataPage.css";

const DataPage = () => {
    const [content, setContent] = useState(DEFAULT_CONTENT.data);
    const [sources, setSources] = useState([]);

    useEffect(() => {
        let cancelled = false;

        fetchContent()
            .then((data) => {
                if (!cancelled && data?.data) setContent(data.data);
            })
            .catch(() => {
                // Бэкенд недоступен — остаёмся на дефолтном тексте.
            });

        fetchDataSources()
            .then((data) => {
                if (!cancelled) setSources(data);
            })
            .catch(() => {
                // Бэкенд недоступен — список источников останется пустым.
            });

        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <div className="page-shell data-page">
            <h1 className="page-heading">{content.heading}</h1>
            <p className="page-subheading">{content.subheading}</p>

            <div className="card data-sources-card">
                <h3 className="data-sources-title">{content.sourcesTitle}</h3>
                {sources.length === 0 ? (
                    <p className="data-sources-empty">
                        Источники пока не добавлены.
                    </p>
                ) : (
                    <ul className="data-sources-list">
                        {sources.map((source, i) => (
                            <li
                                className={`data-source-item ${
                                    i % 2 === 0
                                        ? "accent-blue"
                                        : "accent-orange"
                                }`}
                                key={source.id}
                            >
                                <span className="data-source-dot" />
                                <div className="data-source-body">
                                    <span className="data-source-name">
                                        {source.name}
                                    </span>
                                    <a
                                        className="data-source-link"
                                        href={source.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <LinkIcon
                                            className="data-source-link-icon"
                                            size={16}
                                            strokeWidth={2.2}
                                            aria-hidden="true"
                                        />
                                        {source.url}
                                    </a>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default DataPage;
